module.exports = __webpack_public_path__ + "img/characterAnime3.68bce85b.png";